"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkActivation = checkActivation;

var _checks = require("../../checks");

var _formatErrors = _interopRequireDefault(require("../../utilities/formatErrors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
*   Checks Experiment Activation Event
*   Expected GQL Shape:
*   experiment(id: $id) {
      activationEventUuid
    }
*/
function checkActivation(experiment) {
  const {
    activationEventUuid
  } = experiment;
  const checks = {
    activationEventUuid: (0, _checks.checkString)(activationEventUuid, (0, _checks.missingError)('activation event'))
  };
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}